// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/classInfo';
// 科目管理
import SubjectTree from '@/views/goods/subjectTree';
// 学员管理
import Student from '@/views/goods/student/student';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';

/**
 * 订单管理
 */
// 发卡记录
import SendCard from '@/views/order/sendCard';
// 购卡记录
import BuyCard from '@/views/order/buyCard';
// 充值记录
import TopUpRecord from '@/views/order/topUpRecord';
// 提现
import Withdraw from '@/views/order/withdraw';
// 礼品卡管理
import GiftCard from '@/views/order/giftCard';

/**
 * 统计管理
 */
// 渠道客户统计
import ChannelStatistics from '@/views/statistics/channelStatistics';
// 机构客户统计
import InstitutionStatistics from '@/views/statistics/institutionStatistics';

/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 角色管理
import Role from '@/views/system/Role';
// 充值
import TopUp from '@/views/system/topUp';
// 学员管理
import SysStudent from '@/views/system/student'
// 机构管理
import OrgManage from '@/views/system/orgManage'
// 系统设置
import SysSetting from '@/views/system/sysSetting'
// 提现订单管理
import CashOrder from '@/views/system/cashOrder'

/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/goods/classInfo',
            name: '班组管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/goods/subjectTree',
          name: '科目管理',
          component: SubjectTree,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/goods/student',
          name: '学员管理',
          component: Student,
          meta: {
            requireAuth: true
          }
        }, {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/sendCard',
            name: '发卡记录',
            component: SendCard,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/buyCard',
            name: '购卡记录',
            component: BuyCard,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/topUpRecord',
            name: '充值记录',
            component: TopUpRecord,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/order/withdraw',
          name: '提现',
          component: Withdraw,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/order/giftCard',
          name: '礼品卡管理',
          component: GiftCard,
          meta: {
            requireAuth: true
          }
        }, {
            path: '/statistics/channelStatistics',
            name: '渠道客户统计',
            component: ChannelStatistics,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/statistics/institutionStatistics',
            name: '机构客户统计',
            component: InstitutionStatistics,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/system/topUp',
          name: '充值',
          component: TopUp,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/sysSetting',
          name: '系统设置',
          component: SysSetting,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/cashOrder',
          name: '提现订单管理',
          component: CashOrder,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/orgManage',
          name: '机构管理',
          component: OrgManage,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/student',
          name: '学员管理',
          component: SysStudent,
          meta: {
            requireAuth: true
          }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js